module.exports = __webpack_public_path__ + "static/media/family-m-2.c7c8efc3.png";